module.exports = __webpack_public_path__ + "static/media/mu-logo.cf628747.png";